/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventoryWiseUsage {
    getFixupPrototypeFunction() { return InventoryWiseUsage.fixupPrototype; }

    static newInstance(model: Partial<InventoryWiseUsage>): InventoryWiseUsage {
        let obj = Object.assign(new InventoryWiseUsage(), model);
        InventoryWiseUsage.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventoryWiseUsage>): InventoryWiseUsage {
        if (!model) return null;
        return InventoryWiseUsage.newInstance(<InventoryWiseUsage> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventoryWiseUsage) {
        if (!obj) return;

        models.InventoryWiseUsage.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventoryWiseUsage): boolean {
        Object.setPrototypeOf(obj, InventoryWiseUsage.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.top_consumption) {
            for (let val of this.top_consumption) {
                models.TopConsumptionUsage.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the service
     */
    service_name: string;

    /**
     * Name of the tenant
     */
    tenant_name: string;

    service_accounts: Array<string>;

    /**
     * Total count of the inventory usage
     */
    total_count: number;

    /**
     * List of top consumption usage data
     */
    top_consumption: Array<models.TopConsumptionUsage>;

}
